// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {routerActions} from 'react-router-redux';

export const completePercentageDebit = auditNumber =>
    dispatch => {

        if (auditNumber) {

            dispatch(routerActions.push(`/tcsm/audits/record?auditNumber=${auditNumber}`));

        } else {

            dispatch(routerActions.goBack());

        }

    };

export const updatePercentageDebitComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_PERCENTAGE_DEBIT_COMMENTS
});

export const resetPercentageDebit = () => ({
    type: actions.RESET_TCSM_PERCENTAGE_DEBIT
});



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/action-creators/debit.js